import { array } from 'fp-ts';
import { IconName, Stack, StackItem, ActionToolbarButton, ActionToolbar } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { PortfolioProductOverviewEntry } from '@mews-commander/data-access';
import { useDeleteServiceProductDialog } from '../../../hooks/useDeleteServiceProductDialog';

interface Props {
    selectedRows: PortfolioProductOverviewEntry[];
    resetRowSelection: () => void;
}
export const BulkActions = ({ selectedRows, resetRowSelection }: Props) => {
    const selectedRowsAmount = selectedRows.length;

    const serviceProductIds = selectedRows.map(({ id }) => id);

    const { confirmationDialog, openConfirmationDialog } = useDeleteServiceProductDialog({
        productIds: serviceProductIds,
        onSuccess: resetRowSelection,
    });

    return (
        <>
            <ActionToolbar
                disabled={!selectedRowsAmount}
                leftSide={
                    array.isNonEmpty(selectedRows) && (
                        <Stack itemAlignment="center" spacing="200">
                            <StackItem>{lt('SelectedItems', { count: selectedRowsAmount })}</StackItem>
                            <StackItem>
                                <ActionToolbarButton icon={IconName.ClearSelection} onClick={resetRowSelection}>
                                    {lt('ClearSelection')}
                                </ActionToolbarButton>
                            </StackItem>
                        </Stack>
                    )
                }
                rightSide={
                    <ActionToolbarButton
                        icon={IconName.Delete}
                        disabled={!selectedRowsAmount}
                        onClick={openConfirmationDialog}
                    >
                        {lt('Delete')}
                    </ActionToolbarButton>
                }
            />
            {confirmationDialog}
        </>
    );
};
